"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Endpoint_1 = require("./Endpoint");
/**
 * Object to provide necessary information for an Adapter
 */


var AdapterConfiguration =
/** @class */
function () {
  /**
   * Create a new Configuration instance
   *
   * `fetchCallback` can be used to provide a custom function which will perform the XHR requests.
   * If none is given [`fetch()`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API) will be used
   *
   * @param {EndpointInterface} endpoint
   * @param {RequestInit} requestSettings
   * @param {FetchCallback} fetchCallback
   */
  function AdapterConfiguration(endpoint, requestSettings, fetchCallback) {
    if (requestSettings === void 0) {
      requestSettings = {};
    }

    this.requestSettings = requestSettings;
    this.fetchCallback = fetchCallback;
    this.endpoint = endpoint;
  }
  /**
   * Build a new Configuration instance from the given URL
   *
   * @param {URL | Location} url
   * @param {RequestInit} requestSettings
   * @return {AdapterConfiguration}
   */


  AdapterConfiguration.fromUrl = function (url, requestSettings) {
    if (requestSettings === void 0) {
      requestSettings = {};
    }

    return new this(Endpoint_1.Endpoint.fromUrl(url), requestSettings);
  };

  Object.defineProperty(AdapterConfiguration.prototype, "hostname", {
    /**
     * Return the hostname, IPv4 or IPv6
     *
     * @return {string}
     */
    get: function get() {
      return this.endpoint.hostname;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AdapterConfiguration.prototype, "protocol", {
    /**
     * Return the protocol to use
     *
     * Includes a trailing colon (`:`)
     *
     * @return {string}
     */
    get: function get() {
      return this.endpoint.protocol;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AdapterConfiguration.prototype, "port", {
    /**
     * Return the port number to use
     *
     * @return {number | undefined}
     */
    get: function get() {
      return this.endpoint.port;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AdapterConfiguration.prototype, "path", {
    /**
     * Return the base path/version for requests
     *
     * @return {string}
     */
    get: function get() {
      return this.endpoint.path;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AdapterConfiguration.prototype, "fetchCallback", {
    /**
     * Return the method to use to make XHR requests
     *
     * @return {FetchCallback | undefined}
     */
    get: function get() {
      return this._fetchCallback;
    },

    /**
     * Set the method to use to make XHR requests
     *
     * @param {FetchCallback | undefined} fetchCallback
     */
    set: function set(fetchCallback) {
      if (fetchCallback !== undefined && typeof fetchCallback !== 'function') {
        throw new TypeError('Argument "fetchCallback" must either be `undefined` or a function returning a Promise');
      }

      this._fetchCallback = fetchCallback;
    },
    enumerable: true,
    configurable: true
  });
  return AdapterConfiguration;
}();

exports.AdapterConfiguration = AdapterConfiguration;